import React, { useState, useRef } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
interface AccordionProps {
  title: React.ReactNode;
  subtitle?: React.ReactNode;
  icon?: React.ReactNode;
  children: React.ReactNode;
  isOpen: boolean;
  onToggle: () => void;
  className?: string;
  headerClassName?: string;
}
export function Accordion({
  title,
  subtitle,
  icon,
  children,
  isOpen,
  onToggle,
  className = '',
  headerClassName = ''
}: AccordionProps) {
  return <div className={`rounded-xl overflow-hidden ${className}`} data-id="element-1">
      <button onClick={onToggle} className={`w-full flex items-center justify-between p-4 text-left transition-colors ${headerClassName}`} data-id="element-2">
        <div className="flex items-center gap-3" data-id="element-3">
          {icon && <span className="text-2xl" data-id="element-4">{icon}</span>}
          <div data-id="element-5">
            <div className="font-bold text-lg" data-id="element-6">{title}</div>
            {subtitle && <div className="text-sm opacity-80 mt-1" data-id="element-7">{subtitle}</div>}
          </div>
        </div>
        <motion.div animate={{
        rotate: isOpen ? 180 : 0
      }} transition={{
        duration: 0.2
      }} data-id="element-8">
          <ChevronDown className="w-5 h-5" data-id="element-9" />
        </motion.div>
      </button>
      <AnimatePresence initial={false} data-id="element-10">
        {isOpen && <motion.div initial={{
        height: 0,
        opacity: 0
      }} animate={{
        height: 'auto',
        opacity: 1
      }} exit={{
        height: 0,
        opacity: 0
      }} transition={{
        duration: 0.3,
        ease: 'easeInOut'
      }} className="overflow-hidden" data-id="element-11">
            <div className="p-4 pt-0" data-id="element-12">{children}</div>
          </motion.div>}
      </AnimatePresence>
    </div>;
}